import { useEffect, useState } from 'react';

/**
 * 延迟置真：value 持续为 true 超过 delay 毫秒后才返回 true；变 false 立即复位。
 * 用于 loading 遮罩防闪：短于 delay 的加载过程（缓存命中/快速响应）完全不渲染遮罩，
 * 弱网慢请求时遮罩照常出现，避免用户面对无反馈的空白期。
 *
 * @param {boolean} value 目标布尔值
 * @param {number} delay 延迟毫秒数
 * @returns {boolean} 延迟后的布尔值
 */
const useDelayedFlag = (value, delay = 800) => {
  const [delayedValue, setDelayedValue] = useState(false);

  useEffect(
    () => {
      if (!value) {
        setDelayedValue(false);
        return undefined;
      }

      const timer = setTimeout(() => {
        setDelayedValue(true);
      }, delay);

      return () => clearTimeout(timer);
    },
    [value, delay]
  );

  return delayedValue;
};

export default useDelayedFlag;
